import { selectWarehouses, selectWarehouseStatesRefreshDate } from './warehousesSlice'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'
import { ReactComponent as Mag } from 'assets/magLogo.svg'
import useTranslation from 'hooks/useTranslation'
import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Warehouse from './WarehouseComponent'
import { useSelector } from 'react-redux'
import { Autoplay } from 'swiper/modules'
import Player from 'components/Player'

import 'swiper/css/autoplay'
import 'swiper/css'

interface SlideShowProps {
  startIndex?: number
  autoplay?: boolean
  showInfo?: boolean
  actionInAllSlides?: boolean
  action: (id: string) => void
}

const type = process.env.REACT_APP_TYPE
// szerokość slajdu + marginesy (patrz .warehouse__slide w style.scss) – do decyzji o pętli karuzeli
const SLIDE_STEP = type === 'ldz01' ? 328 : 244

const SlideShow: React.FC<SlideShowProps> = ({ startIndex = 0, autoplay = false, showInfo = false, actionInAllSlides = false, action }) => {

  const [isPreview, showPreview] = useState(false)
  const refreshDate = useSelector(selectWarehouseStatesRefreshDate)
  const warehouses = useSelector(selectWarehouses)
  const index = useRef(startIndex)

  const { push } = useHistory()
  const { t } = useTranslation()

  return (
    <Swiper
      grabCursor
      speed={1000}
      centeredSlides
      slideToClickedSlide
      touchMoveStopPropagation
      modules={[Autoplay]}
      preventClicks={true}
      slidesPerView='auto'
      initialSlide={startIndex}
      autoplay={autoplay ? { delay: 5000 } : false}
      loop={warehouses.length > 1 && ((warehouses.length * SLIDE_STEP) > window.innerWidth)}
      onTransitionEnd={({ realIndex }: SwiperClass) => {
        index.current = realIndex
      }}
      onSlideChange={({ realIndex }: SwiperClass) => {
        actionInAllSlides && warehouses[realIndex] && action(warehouses[realIndex]?.objectId)
      }}>

      {warehouses.map((warehouse, i) => {
        const { objectId, contractId, isShared, name, typeName, clientName, clientSurname, placeName, placeAddress, placeShortAddress, warehouseCamera } = warehouse
        return <SwiperSlide
          key={contractId}
          className='warehouse__slide'>
          {({ isActive }) => <div
            className={`slide${isActive ? ' --selected' : ''}`}
            onClick={() => {
              if (i === index.current) action(objectId)
            }}>

            {isActive && warehouseCamera && type === 'mm' && <div
              className='warehouse__previewBtn'
              onClick={() => {
                showPreview(prev => !prev)
              }}>
              <i className='icon icon--monitoring s32' />
            </div>}

            {isActive && isPreview && warehouseCamera
              ? <Player
                camera={warehouseCamera?.hqCam || warehouseCamera?.defaultCam}
              />
              : <Warehouse
                {...warehouse}
              />}

            {(isActive && showInfo) && <div className='warehouse__info'>
              <div className='info__text info__title'>
                <div className='--secFont'>{typeName} nr. {name}</div>
                {isShared && <div className='center --gap1'><i className='icon icon--share' /><span>{clientName} {clientSurname}</span></div>}
              </div>
              <div className='info__text info__desc'>
                <div>{placeName}</div>
                <div>{placeAddress}</div>
              </div>
            </div>}

            {(isActive && !showInfo) && <div className='warehouse__info'>
              <div className='info__text info__desc'>
                <div
                  className='warehouse__info__label'
                  onClick={() => {
                    window.open(`https://www.google.com/maps/search/?api=1&query=${placeAddress}`)
                  }}>
                  <i className='icon icon--location-500' />
                  <span>{placeShortAddress}</span>
                </div>
                {refreshDate && type === 'mm' && <div className='--small'>{t('basic.lastSync')}: {new Date(refreshDate).toLocaleTimeString()}</div>}
              </div>
            </div>}
          </div>}
        </SwiperSlide>
      })}

      <SwiperSlide className='warehouse__slide commercial center'>
        {({ isActive }) => <div className={`slide${isActive ? ' --selected' : ''}`}>
          {type === 'mm'
            ? <div
              className='warehouse__commercial center'
              onClick={() => {
                push('/categories')
              }}>
              <div className='commercial__title --secFont'>{t('warehouse.rentANewOne')}</div>
              <Mag />
            </div>
            : <div
              className='warehouse__commercial center'
              onClick={() => {
                push('/home')
              }}>
              <div className='commercial__title --secFont'>{t('warehouse.rentANewOne')}</div>
              <div className='commercial__title--secondary --secFont'>{t((type === 'rze01' || type === 'chr01' || type === 'box' || type === 'demo') ? `basic.box.${type}` : 'basic.warehouse')}</div>
            </div>}
        </div>}
      </SwiperSlide>
    </Swiper>
  )
}

export default SlideShow